export enum PlatformScope {
    ApplianceDriverImageManagement = "appliance-driver-image-management",
    HalImageManagement = "hal-image-management",
    LocalApplicationImageUpload = "local-application-image-upload",
    AuthorizationManagement = "authorization-management",
    ControllerPlatform = "controller-platform",
    ReadComponents = "read-components",
    EndpointCreation = "endpoint-creation",
    CoreImageManagement = "core-image-management"
}

export enum EndpointScope {
    EndpointDescriptionDocumentManagement = "endpoint-description-document-management",
    HalDescriptionDocumentManagement = "hal-description-document-management",
    LocalApplicationDocumentManagement = "local-application-document-management",
    LiveData = "live-data",
    HistoryData = "history-data",
    AuthorizationManagement = "authorization-management",
    CoreUpdateManagement = "core-update-management",
    EndpointManagement = "endpoint-management",
    Events = "events",
    SetpointsControl = "setpoints-control",
    Status = "status",
    EndpointDescriptionRead = "read-endpoint-description",
    ExternalDataManagement = "external-data-management"
}

export enum LocalApplicationScope {
    Manage = "manage",
    Deploy = "deploy",
    AuthorizationManagement = "authorization-management",
}

export const mqttEndpointScopes: EndpointScope[] = [
    EndpointScope.LiveData,
    EndpointScope.Events,
    EndpointScope.SetpointsControl,
    EndpointScope.Status,
];

export type TokenRequest = {
    client_id: string;
    client_secret: string;
    endpoints: { [key: string]: EndpointScope[] };
    platform_scopes: PlatformScope[];
    application_components: { [key: string]: LocalApplicationScope[] };
    super_token: boolean;    
}
